<ng-container *ngIf="action !== 'workgroupDetail'">
	<app-form-view [popup]="formPopup">
		<form-title>
			{{title}}
		</form-title>
		<content-area>
			<div class="workgroup-form" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px">
				<div fxLayout="row" fxLayoutAlign="center start">
					<div fxFlex="80%" fxFlex.xs="100%" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
						<!-- <div class="form-info">
							<p class="body-text">
								{{info}}
							</p>
						</div> -->
						<div fxLayout="row" fxLayoutAlign="center center">
							<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="95" fxFlex.xs="100" fxLayoutGap="20px"
								fxLayoutGap.xs="10px">
								<div fxLayout fxLayoutAlign="center start" class="form-container">
									<app-form-group [fieldList]="formFields" [config]="config" fxLayout="column"
										fxLayoutAlign="start stretch" fxLayout.xs="column" fxLayoutAlign.xs="start stretch"
										fxLayoutGap="10px" fxLayoutGap.xs="10px" (formObject)="formObjectReader($event)"></app-form-group>
								</div>
								<div fxLayout="column" fxLayoutAlign="start stretch">
									<app-alert id="workgroupAlert"></app-alert>
									<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
										<ng-container *ngIf="action === 'createWorkgroup' || action === 'sendRequest'">
											<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button class="submit-btn"
												type="button">{{locale.translate('submit')}}</button>
										</ng-container>
										<ng-container *ngIf="action === 'inviteUsers'">
											<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button class="submit-btn"
												type="button">{{locale.translate('ok')}}</button>
										</ng-container>
										<ng-container *ngIf="action === 'editWorkgroup'">
											<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button class="submit-btn"
												type="button">{{locale.translate('update')}}</button>
										</ng-container>
										<button [disabled]="submitDisable" (click)="popupRef.close('cancel')" mat-button class="cancel-btn"
											type="button">{{locale.translate('cancel')}}</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</content-area>
	</app-form-view>
</ng-container>

<ng-container *ngIf="action === 'workgroupDetail'">
	<app-content-view>
		<content-title>
			{{title}}
		</content-title>
		<content-area>
			<div class="workgroup-form workgroup-detail-container" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="28px">
				<ng-container *ngIf="workGroupData?.groupDescription">
					<div class="workgroup-dtl-desc">
						<p>{{ workGroupData?.groupDescription }}</p>
					</div>
				</ng-container>
				<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="28px" fxLayout.xs="column"
					fxLayoutAlign.xs="start stretch" fxFlex="95" fxFlex.xs="100%">
					<div fxLayout="column" fxLayoutAlign="start stretch">
						<mat-tab-group class="custom-tab"
							[ngClass]="{'responsive-tab': detectDevice?.resolutionState$?.value?.deviceType === 'mobile'}"
							mat-align-tabs="center" [selectedIndex]="tabIndex" (selectedIndexChange)="tabChange($event)" #tab>
							<mat-tab [label]="locale.translate('assignments')">
								<ng-container *ngIf="tabIndex === 0">
									<app-assignments [workGroupData]="workGroupData" [actionFrom]="actionFrom"
										(assignment)="getCount($event)">
									</app-assignments>
								</ng-container>
							</mat-tab>
							<mat-tab [label]="locale.translate('members')">
								<ng-container *ngIf="tabIndex === 1">
									<app-members [workGroupData]="workGroupData" [actionFrom]="actionFrom" (member)="getCount($event)">
									</app-members>
								</ng-container>
							</mat-tab>
							<mat-tab [label]="locale.translate('activities')">
								<ng-container *ngIf="tabIndex === 2">
									<app-activities [workGroupData]="workGroupData"></app-activities>
								</ng-container>
							</mat-tab>
						</mat-tab-group>
					</div>
				</div>
			</div>
			<!-- <div fxLayout="column" fxLayoutAlign="start stretch">
					<div class="btn-block" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
						<button [disabled]="submitDisable" (click)="popupRef.close('cancel')" mat-stroked-button class="close-btn"
							type="button">{{locale.translate('close')}}</button>
					</div>
				</div> -->
		</content-area>
	</app-content-view>
</ng-container>
